import type { Project } from '../store/AppContext';
import { formatSavedProjectArea } from './projectDisplay';

// Presentation only: keep the saved values and the existing table's fallbacks.
export const PROJECT_LIST_STATUS_LABELS = {
  draft: 'Robocza',
  sent: 'Wysłana',
  accepted: 'Zaakceptowana',
  in_progress: 'W realizacji',
  completed: 'Zakończona',
  rejected: 'Odrzucona',
  cancelled: 'Anulowana',
} satisfies Record<Project['status'], string>;

export function isProjectListStatus(value: string): value is Project['status'] {
  return Object.hasOwn(PROJECT_LIST_STATUS_LABELS, value);
}

const DAY_MS = 24 * 60 * 60 * 1000;

export function getProjectListRow(project: Project, now = Date.now()) {
  return {
    name: project.name,
    client: project.clientName || 'Brak klienta',
    location: project.location || 'Brak lokalizacji',
    area: formatSavedProjectArea(project),
    date: project.date,
    createdDate: new Date(project.createdAt || 0).toLocaleDateString('pl-PL'),
    status: project.status,
    statusLabel: PROJECT_LIST_STATUS_LABELS[project.status],
    price: `${(project.totalBrutto || project.totalDiscountedCost || 0).toLocaleString('pl-PL')} PLN`,
    profit: `${(project.totalProfit || 0).toLocaleString('pl-PL')} PLN`,
    priceMode: project.priceMode || 'Standard',
    isNewAcceptance: Boolean(project.status === 'accepted' && project.clientAcceptedAt && now - project.clientAcceptedAt < DAY_MS),
    waitingDays: project.status === 'sent'
      ? Math.floor((now - ((project.sentAt || project.createdAt) ?? Number.NaN)) / DAY_MS)
      : null,
  };
}

export type ProjectListRow = ReturnType<typeof getProjectListRow>;
